@use '../../styles/variables' as *;

.cols {
}
.inputFormWrap {
  // background-color: rgba(220, 217, 210, 0.44);
  padding: 25px 0px;
  padding-top: 30px;
  padding-bottom: 14px;
  border-radius: $borderRadius;
  text-align: center;
  width: 320px;
  margin: auto;
  // display: inline-block;
  box-sizing: border-box;
  @media screen and (max-width: 600px) {
    width: 100%;
    padding-bottom: 5px;
  }

  h3,
  h5 {
    margin-top: 0;
    margin-bottom: 1.6rem;
    font-size: 1.6rem;
    max-width: 94%;
  }
  .slider {
    // border: 3px solid $textBlack;
    // margin-bottom: 10px;
    & > div:first-child {
      background-color: $green;
      // border: 3px solid $textBlack;
    }
    & > div:last-child {
      div {
        box-shadow: none;
        border: 3px solid $green;
      }
    }
  }
  .buttonCalculator {
    max-width: 100%;
    padding: 14px 30px;
    border-radius: 26px;
    background-color: $green;
    transition: background-color 300ms ease;
    color: #fff;
    font-size: 16px;
    line-height: 100%;
    font-weight: 600;

    text-align: center;
    cursor: pointer;
    display: inline-block;
    text-decoration: none;
    margin-top: 1.5px;
    margin-bottom: 1rem;
    transform: scale(0.9);
    transform-origin: left center;
    // display: none;
    &:after {
      content: '';
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3Cpath style='fill: white;' d='M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z'/%3E%3C/svg%3E");
      background-repeat: no-repeat no-repeat;
      background-position: center center;
      background-size: cover;
      display: inline-block;
      width: 0.7rem;
      height: 0.9rem;
      margin-left: 0.8rem;
      transform: translateY(2px) scale(1);
      transition: all 0.3s ease;
    }
    &:hover {
      background-color: #0a8973;
      &:after {
        transform: translateY(4px);
      }
    }
  }
}
.inputForm {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
  .formCol {
    margin-right: 2rem;
    text-align: left;
    @media screen and (max-width: 600px) {
      margin-right: 0;
      width: 100%;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
.formGroup {
  width: 100%;
  margin-bottom: 15px;
  text-align: left;
  display: flex;
  gap: 1rem;
  align-items: center;
  label {
    display: block;
    font-size: $smallTextSize;
    color: $textBlack;
    margin-top: 6px;
    line-height: 1em;
    font-weight: bold;
    padding-bottom: 12px;
    font-weight: 400;
  }
  input {
    height: 40px;
    font-family: inherit;
    width: 90px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 2px solid $textBlack;
    padding: 0 10px;
    line-height: 100%;
    font-size: $inputTextSize;
    color: $textBlack;
    outline: none;
    transition: all 0.3s;
    &:focus {
      border-color: $lightGreen;
    }
  }
  .MuiSlider {
    span:first-child {
      height: 10px !important;
      background-color: #ddd;
      opacity: 1;
    }
    span:nth-child(2) {
      background-color: $green !important;
      border: 0 !important;
      height: 10px !important;
    }
    span:nth-child(3) {
      background-color: white !important;
      border: 3px solid $green;
      height: 17px;
      width: 17px;
      // box-shadow: none !important;
      cursor: pointer !important;
    }
  }
}
